import { InputLabel } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'
import 'react-phone-input-2/lib/style.css'
export interface InputStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
}

export const CustomInput = styled(PhoneInput)<InputStyles>`
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  width: ${({ width }) => width || '100%'};

  .form-control {
    border: none;
    border-bottom: 0.1rem solid ${COLORS.black};
    border-radius: 0;
  }

  .flag-dropdown {
    background: transparent;
    border: none;
  }
`

export const InputLabelCustom = styled(InputLabel)<InputStyles>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
`
